import Id from './Id';
import Created from './Created';
import Updated from './Updated';
import ResponsibleUser from './ResponsibleUser';
import CreatorUser from './CreatorUser';
import Deadline from './Deadline';
import Title from './Title';
import Status from './Status';
import Description from './Description';
import Subscribers from './Subscribers';

export const labels = {
  Id: 'Azonosító',
  ResponsibleUser: 'Felelős',
  CreatorUser: 'Létrehozó',
  Deadline: 'Határidő',
  Title: 'Cím',
  Status: 'Státusz',
  Description: 'Leírás',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  Subscribers: 'Feliratkozók'
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ResponsibleUser',
  fixed: true,
}, {
  value: 'Title',
}, {
  value: 'Status',
}, {
  value: 'CreatorUser',
}, {
  value: 'Deadline',
}, {
  value: 'Description',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}, {
  value: 'Subscribers',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ResponsibleUser',
  fixed: true,
}, {
  value: 'Status',
}, {
  value: 'Deadline',
}, {
  value: 'Title',
}];

export const defaultSort = {
  prop: Deadline.propName,
  order: 'ascending'
};

export default {
  Id,
  ResponsibleUser,
  Title,
  Status,
  CreatorUser,
  Deadline,
  Description,
  Created,
  Updated,
  Subscribers,
};
